const releaseDate = new Date('30 July 2021 15:00:00 UTC');
export default releaseDate;